const getExpectedBalance = (
	paymentAmount: string | number,
	accountBalance: number,
) => {
	const expectedRemainingBalanceRaw = accountBalance - Number(paymentAmount);
	const expectedCredit =
		expectedRemainingBalanceRaw < 0 ? Math.abs(expectedRemainingBalanceRaw) : 0;
	const expectedRemainingBalance =
		expectedRemainingBalanceRaw < 0 ? 0 : expectedRemainingBalanceRaw;
	const hasExpectedCredit = expectedCredit > 0;

	return {
		expectedCredit,
		expectedRemainingBalance,
		hasExpectedCredit,
	};
};

export default getExpectedBalance;
